import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { Loader as f } from "./contact-channels76.js";
import { FlexBox as r, Typography as l, tokens as u, ResponsiveImage as w } from "@vp/swan";
import b from "./contact-channels83.js";
import x from "./contact-channels82.js";
import { useTranslations as A } from "./contact-channels38.js";
import { useWhatsApp as g } from "./contact-channels7.js";
import { Show as a } from "./contact-channels77.js";
const j = (c) => {
  const { variation: m = "standard", showLoading: h = !0 } = c, { t: i } = A(), { data: n, isLoading: p, isPending: d } = g(), t = !(n != null && n.isAvailable) || p, o = m === "minimal";
  return /* @__PURE__ */ e(
    f,
    {
      skeletonLines: o ? 1 : 2,
      skeletonLineWidths: "narrow",
      isLoading: p || d,
      showLoading: h,
      children: /* @__PURE__ */ s(a, { children: [
        /* @__PURE__ */ e(a.When, { isTrue: o, children: /* @__PURE__ */ e(r, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ e(
          l,
          {
            fontSkin: "title-subsection",
            mb: "4",
            style: { color: t ? u.SwanSemColorTextDisabled : void 0 },
            children: i("whatsApp.title")
          }
        ) }) }),
        /* @__PURE__ */ e(a.When, { isTrue: !o, children: /* @__PURE__ */ s(r, { flexDirection: "column", children: [
          /* @__PURE__ */ e(l, { fontSkin: "title-subsection", mb: "4", children: i("whatsApp.title") }),
          /* @__PURE__ */ s(r, { id: "salesforceWhatsAppStatusDiv", children: [
            /* @__PURE__ */ e(w, { role: "presentation", src: t ? x : b, alt: "", width: "12px" }),
            /* @__PURE__ */ e(l, { fontSkin: "title-item", component: "span", ml: "3", children: i(t ? "whatsApp.offline.status" : "whatsApp.online.status") })
          ] })
        ] }) })
      ] })
    }
  );
};
export {
  j as WhatsAppHeader
};
//# sourceMappingURL=contact-channels33.js.map
